import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { TranslationService } from '../../../core/services/translation-service';
import { LanguageInfo } from '../../../core/translation.config';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-language-translation',
  templateUrl: './language-translation.html',
  styleUrl: './language-translation.scss',
  standalone: false,
})
export class LanguageTranslation {
  isOpen = false;
  languages: LanguageInfo[] = [];
  current$!: Observable<string>;

  constructor(private router: Router,
    private i18n: TranslationService
  ) { }

  ngOnInit(): void {
    this.languages = this.i18n.getLanguages();
    this.current$ = this.i18n.languageChanges$();
  }

  toggleDropdown(event: Event) {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.isOpen = false;
  }

  onChange(lang: string) {
    this.i18n.setLanguage(lang);
    this.isOpen = false; 
  }

  getCurrentLanguageName(): string {
    return this.i18n.getCurrentLanguageName();
  }
}
